export default __webpack_public_path__ + "24bf815.png";